import { Formik } from 'formik'

import { ModalWrapper } from 'src/components'
import { useUpdateAccount2FARequirement, useAccount } from 'src/hooks'
import { TwoFAModalInner } from './2fa-update-modal-inner.component'

import { useStyles } from './styles'

interface IProps {
  open: boolean
  handleClose: () => void
}

export const Modal = ({ open, handleClose }: IProps) => {
  const { mutateAsync: update2FARequirement } = useUpdateAccount2FARequirement()
  const { data: account } = useAccount()
  const classes = useStyles()

  const handleSubmit = async (values: { required: boolean }) => {
    await update2FARequirement(values.required)
    handleClose()
  }

  if (!account) return null

  return (
    <ModalWrapper className={classes.formWrapper} onClose={handleClose} open={open}>
      <Formik initialValues={{ required: account.two_factor_required }} onSubmit={handleSubmit}>
        <TwoFAModalInner />
      </Formik>
    </ModalWrapper>
  )
}
